import { useEffect, useState } from 'react';

/**
 * 컴포넌트 마운트 여부 확인하기 위한 hook
 *
 * @returns 마운트 여부
 */
export function useIsMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);
  return mounted;
}
